import AxiosInstance from "../../../shared/utils/axios";
import InsigtsAPIAxiosInstance from "../../../shared/utils/insightsAxios";

export const getCachedAutozonesData = async (fieldId: string): Promise<any> => {
  try {
    const response = await AxiosInstance.get(`/auto_zones/${fieldId}`);
    if (response.data?.status === "IN PROGRESS") {
      // Wait 30 seconds and retry
      console.warn(
        "Autozone generation in progress, retrying in 30 seconds..."
      );

      await new Promise((resolve) => setTimeout(resolve, 30000));
      return await getCachedAutozonesData(fieldId);
    } else if (response.data?.status === "SUCCESSFUL" || response.data?.status === "SUCCESSFULL") {
      return response.data.content;
    } else {
      console.error("error fetching auto zones:", response.data.status);
    }
  } catch (error) {
    console.error("Error fetching auto zones data:", error);
  }
};

// BELOW SERVICES ARE NOW USED AND CACHED BY BACKEND

export const getProductivityZones = async (
  fieldId: string,
  seasons: any
): Promise<any> => {
  const payload = {
    request_version: "v1.0",
    fields: [
      {
        id: `cwp:base::field:id:${fieldId}`,

        seasons, // for prodzones

        query: {
          output_format: "geojson",
        },

        models: [
          {
            name: "zoning",
            version: "v1.0",
            models: [
              {
                name: "productivity_zones",
                version: "v1.0",
              },
            ],
          },
        ],
      },
    ],
  };
  try {
    const response = await InsigtsAPIAxiosInstance.post(
      "/predictions",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching productivity zones data:", error);
  }
};

export const getIntervalSuggestions = async (fieldId: string): Promise<any> => {
  const payload = {
    request_version: "v1.0",
    fields: [
      {
        id: `cwp:base::field:id:${fieldId}`,

        query: {
          output_format: "geojson",
        },

        models: [
          {
            name: "zoning",
            version: "v1.0",
            models: [
              {
                name: "interval_suggestion",
                version: "v1.0",
              },
            ],
          },
        ],
      },
    ],
  };
  try {
    const response = await InsigtsAPIAxiosInstance.post(
      "/predictions",
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching Autozones Interval Suggestions model:",
      error
    );
  }
};

export const getVariabilityIndex = async (fieldId: string): Promise<any> => {
  const payload = {
    request_version: "v1.0",
    fields: [
      {
        id: `cwp:base::field:id:${fieldId}`,
        query: {
          output_format: "geojson",
        },

        models: [
          {
            name: "zoning",
            version: "v1.0",
            models: [
              {
                name: "variability_index",
                version: "v1.0",
              },
            ],
          },
        ],
      },
    ],
  };
  try {
    const response = await InsigtsAPIAxiosInstance.post(
      "/predictions",
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching Autozones Interval Suggestions model:",
      error
    );
  }
};
